// Key-value table (table.kv): 13 px rows with hairline dividers, keys left and semibold tabular values right.
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

export interface KeyValueRow {
  key: string;
  label: ReactNode;
  value: ReactNode;
}

export function KeyValueTable({
  rows,
  caption,
  className,
}: {
  rows: readonly KeyValueRow[];
  caption?: string;
  className?: string;
}) {
  return (
    <table className={cn("w-full border-collapse text-ui", className)}>
      {caption ? <caption className="sr-only">{caption}</caption> : null}
      <tbody>
        {rows.map((row) => (
          <tr key={row.key} className="border-b border-border-subtle last:border-b-0">
            <th scope="row" className="py-2 pr-3 text-left font-normal text-ink-2">
              {row.label}
            </th>
            <td className="py-2 text-right font-semibold tabular-nums">{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
